import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { SanitizerHtmlPipe } from '../../pipes/sanitizer-html.pipe';

@Component({
    selector: 'modal-loading',
    templateUrl: './modal-loading.component.html',
    styleUrls: ['./modal-loading.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogClose, MatIcon, SanitizerHtmlPipe]
})
export class ModalLoadingComponent implements OnInit {

    firstText = '';
    secondText = '';
    loadingGenerico = false;
    erroLoading = false;
    title: string;
    text1: string;
    text2: string;
    textButton: string;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

    ngOnInit(): void {
        this.inicializaCampos();
    }

    private inicializaCampos() {
        this.erroLoading = this.data.erroLoading;
        this.title = this.data.title;
        this.text1 = this.data.text1;
        this.text2 = this.data.text2;
        this.textButton = this.data.textButton;

        this.firstText = this.text1 ?? '';
        this.secondText = this.text2 ?? '';
    }

}
